module.exports = __webpack_public_path__ + "img/css.7e1e0b72.svg";